'use client'

// Third-party Imports
import { SessionProvider } from 'next-auth/react'
import type { SessionProviderProps } from 'next-auth/react'

export const NextAuthProvider = ({ children, ...rest }: SessionProviderProps) => {
  // refetchOnWindowFocus=false: evita refetch sessione al rientro tab → niente remount/flash dei drawer
  return <SessionProvider refetchOnWindowFocus={false} {...rest}>{children}</SessionProvider>
}
